import React, { useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { ucFirst } from "../../../util/Helpers";

export const BreadCrumbs = () => {
    const { breadcrumbs, setBreadcrumbs } = useSubheader();
    const location = useLocation();

    useLayoutEffect(() => {
        const breadcrumbList = []
        let subPath = "/"
        location.pathname.split("/").forEach(element => {
            if (element) {
                const show = !element.startsWith("view") && !element.startsWith("create") && !element.startsWith("edit")
                show && breadcrumbList.push({
                    "pathname": subPath + element,
                    "title": element
                })
                subPath += element + "/"
            }
        });
        setBreadcrumbs(breadcrumbList);
    }, [location.pathname, setBreadcrumbs]);

    if (!breadcrumbs || !breadcrumbs.length) {
        return "";
    }

    return (
        <ul className="p-0 m-0 d-flex" style={{ listStyle: "none" }}>
            {breadcrumbs.map((item, index) => (
                <span key={index} className="d-flex align-items-center">
                    {
                        index > 0 &&
                        <div
                            style={{ height: "4px", width: "4px" }}
                            className="rounded-circle bg-primary mx-1"
                        />
                    }
                    <li>
                        <Link
                            className="text-dark text-hover-primary"
                            to={{ pathname: item.pathname }}
                        >
                            {ucFirst(item.title)}
                        </Link>
                    </li>
                </span>
            ))}
        </ul>
    );
}